/* ==========================================================================
   Searcher > Client > Destination
   ========================================================================== */

/* Modules */
const selectClient = require('../../../../select-panel/client/js');
const selectActions = require('../../../../select-panel/client/js/store/actions');

const { types } = require('../store/actions');
const { setRoute } = require('../services');
const { firstAvailableDates } = require('../helpers');
const { validateDestination } = require('../validations');

const configuration = require('../config');

/* Init Destination */
function initDestination(instance) {
    const inst = instance;
    const { selector } = instance;

    /* Init desetination Panel */
    inst.destination = selectClient(
        `${selector} [data-component="SelectPanel"][data-type="${configuration().type.destination}"]`
    );

    /* Extend subscription */
    if (!inst.destination) return;

    /* Extends reactions */
    inst.reactions = {
        ...inst.reactions,
        openDestination: inst.destination.store.subscribe((state, action) => {
            if (action.type !== selectActions.types.OPEN_PANEL) return;

            inst.actions.openPanel('destination');
        }),
        closeDestination: inst.destination.store.subscribe((state, action) => {
            if (action.type !== selectActions.types.CLOSE_PANEL) return;

            inst.actions.closePanel('destination');
        }),
        changeRoute: inst.store.subscribe((state, action) => {
            if (action.type !== types.CHANGE_DATA || !action.payload || !action.payload.route) return;

            const { startDate, endDate } = firstAvailableDates(inst);

            if (startDate && endDate) instance.actions.changeData({ dates: [startDate, endDate] });
        }),
        changeDestination: inst.destination.store.subscribe((state, action) => {
            if (action.type !== selectActions.types.CHANGE_VALUE && action.type !== selectActions.types.CHANGE_OPTIONS)
                return;

            /* Data  destination store */
            const { value } = instance.destination.store.select('data');

            /* Sync store */
            instance.actions.changeData({ destination: value });

            /* Validate */
            validateDestination(inst);

            /* Data store */
            const { origin, destination } = instance.store.select('data');

            /* Get Operative */
            if (origin && destination) {
                setRoute(instance);
                return;
            }

            /* Sync store, reset discounts and bonus */
            instance.actions.setData({ discounts: {}, bonus: {} });
        })
    };
}

/* Exports */
module.exports = {
    initDestination
};
